import { lightTheme } from '@/customTheme'
import Icons from '@/scenes/Editor/components/Icons'
import { useTranslation } from 'react-i18next'
import AppStore from '@assets/images/social_proof/app_store.png'
import GooglePlay from '@assets/images/social_proof/google_play.png'

const PAYMENT_REASSURANCE_ITEMS = [
  'No charge until trial ends',
  'Cancel in one click',
  'Secure checkout',
]

function PaymentInfo({
  planActive,
  planDetail,
  planType,
}: {
  planActive: number
  planDetail: any
  planType: 'premium' | 'super'
}) {
  const { t } = useTranslation()
  const canFreeTrial = planActive === 2
    ? planDetail?.year?.canFreeTrial
    : planDetail?.month?.canFreeTrial
  const selectedTrialDays = planActive === 2
    ? planDetail?.year?.trialDays ?? 0
    : planDetail?.month?.trialDays ?? 0

  const reassuranceItems =
    planType === 'premium' && canFreeTrial
      ? PAYMENT_REASSURANCE_ITEMS
      : PAYMENT_REASSURANCE_ITEMS.filter(item => item !== 'No charge until trial ends')

  return (
    <>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <div style={{ width: '293px' }}>
          <h4
            style={{
              margin: 0,
              ...lightTheme.typography.Header20semibold,
            }}
          >
            {planType === 'premium' && canFreeTrial
              ? t('%d days free', { arg: selectedTrialDays })
              : planType === 'premium'
              ? t('Included in Premium')
              : t('Included in Super')}
          </h4>
          <h5
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              gap: '8px',
              marginBottom: 0,
              marginTop: '22px',
              ...lightTheme.typography.Small16Bold,
              fontWeight: 600,
            }}
          >
            {t(
              `${
                planType === 'premium' && canFreeTrial ? 'then ' : ''
              }%@ per ${planActive === 2 ? 'year' : 'month'}`,
              { arg: planActive === 2 ? planDetail?.year?.price : planDetail?.month?.price }
            )}
            . {t('Cancel anytime.')}
          </h5>
          {reassuranceItems.map((item, index) => (
            <p
              key={index}
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                gap: '8px',
                marginBottom: 0,
                marginTop: '22px',
                ...lightTheme.typography.Small14regular,
              }}
            >
              <Icons.CheckIcon fill="#FF0560" />
              <span style={{ ...lightTheme.typography.Small14regular }}>{t(item)}</span>
            </p>
          ))}
        </div>
        <div style={{ display: 'flex', gap: '8px', justifyContent: 'space-between', width: '293px', height: '62px', marginTop: '40px' }}>
          <img src={AppStore} alt="Best of App Store" />
          <img src={GooglePlay} alt="Best of Google Play" />
        </div>
      </div>
      {planType === 'premium' && canFreeTrial && (
        <p
          style={{
            ...lightTheme.typography.Small12medium,
            color: lightTheme.colors.grayScale400,
            position: 'absolute',
            bottom: '16px',
            left: 0,
            right: 0,
            textAlign: 'center',
          }}
        >
          {t("Free trial available if you haven't used it before.")}
        </p>
      )}
    </>
  )
}

export default PaymentInfo
